import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid
} from "@mui/material";

export default function ModalCadastroEntregador({
  open,
  onClose,
  entregadorSelecionado
}) {
  const [codigo, setCodigo] = useState("");
  const [nome, setNome] = useState("");
  const [numero, setNumero] = useState("");

  useEffect(() => {
    if (entregadorSelecionado) {
      setCodigo(entregadorSelecionado.codigo || "");
      setNome(entregadorSelecionado.nome || "");
      setNumero(entregadorSelecionado.numero || "");
    } else {
      setCodigo("");
      setNome("");
      setNumero("");
    }
  }, [entregadorSelecionado]);

  const handleSalvar = () => {
    const payload = {
      codigo,
      nome,
      numero
    };

    console.log("Salvar entregador:", payload);
    // 👉 chamada da API aqui

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cadastro de Entregador</DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12}>
            <TextField
              label="Código"
              value={codigo}
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Número"
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
              fullWidth
              required
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleSalvar} variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}